import { useAppQuery } from "../../../http/useAppQuery.ts";
import { selectedAssetUuidStore } from "../../boardState/stores/selectedAssetUuidStore.ts";
import type { DetailedAsset } from "../types.ts";

export const useSelectedAsset = () => {
  const { selectedAssetUuid } = selectedAssetUuidStore.useState();
  const assetQuery = useAppQuery<DetailedAsset>({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryKey: `assets/${selectedAssetUuid!}`,
    enabled: !!selectedAssetUuid,
  });

  return {
    selectedAsset: assetQuery.data,
    isLoading: assetQuery.isLoading,
  };
};
